var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdvantageIconGreen2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 17.2H11.2V26.8H4V17.2ZM20.8 11.2H28V26.8H20.8V11.2ZM12.4 5.19995H19.6V26.8H12.4V5.19995ZM6.4 19.6V24.4H8.8V19.6H6.4ZM14.8 7.59995V24.4H17.2V7.59995H14.8ZM23.2 13.6V24.4H25.6V13.6H23.2Z",
    fill: "#9A9A9A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 17.2H11.2V26.8H4V17.2ZM20.8 11.2H28V26.8H20.8V11.2ZM12.4 5.19995H19.6V26.8H12.4V5.19995ZM6.4 19.6V24.4H8.8V19.6H6.4ZM14.8 7.59995V24.4H17.2V7.59995H14.8ZM23.2 13.6V24.4H25.6V13.6H23.2Z",
    fill: "url(#paint0_linear_740_3522)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_740_3522",
    x1: 16,
    y1: 5.19995,
    x2: 16,
    y2: 26.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34C759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008B1D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvantageIconGreen2);
export default __webpack_public_path__ + "static/media/advantage_icon_green2.420b7f6bcc3a7ef500234777ba725f72.svg";
export { ForwardRef as ReactComponent };